/** Türkiye is UTC+3 all year (no DST since 2016). All display formatting goes through here. */
export const TZ = 'Europe/Istanbul';
export const IST_OFFSET_MS = 3 * 3600_000;

const DAYS_TR = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];
const DAYS_L_TR = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
const MON_TR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
const MON_L_TR = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const DAYS_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const DAYS_L_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MON_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MON_L_EN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export type Lang = 'tr' | 'en';

/** Istanbul wall-clock parts of an epoch ms. */
export function ist(ms: number) {
  const d = new Date(ms + IST_OFFSET_MS);
  return { y: d.getUTCFullYear(), mo: d.getUTCMonth(), d: d.getUTCDate(), wd: d.getUTCDay(), h: d.getUTCHours(), mi: d.getUTCMinutes() };
}

/** Epoch ms of Istanbul midnight for the day containing `ms`. */
export function istMidnight(ms: number) {
  const p = ist(ms);
  return Date.UTC(p.y, p.mo, p.d) - IST_OFFSET_MS;
}

/** Epoch for "day offset N from today's Istanbul midnight at HH:MM". */
export function istAt(baseMidnight: number, dayOffset: number, hhmm: string) {
  const [h, m] = hhmm.split(':').map(Number) as [number, number];
  return baseMidnight + dayOffset * 86400_000 + h * 3600_000 + m * 60_000;
}

export const hhmm = (ms: number) => {
  const p = ist(ms);
  return `${String(p.h).padStart(2, '0')}:${String(p.mi).padStart(2, '0')}`;
};

/** "Cmt 3 Eki" / "Sat 3 Oct" */
export function dayShort(ms: number, lang: Lang = 'tr') {
  const p = ist(ms);
  return lang === 'en' ? `${DAYS_EN[p.wd]} ${p.d} ${MON_EN[p.mo]}` : `${DAYS_TR[p.wd]} ${p.d} ${MON_TR[p.mo]}`;
}

/** "3 Ekim Cumartesi" / "Saturday 3 October" */
export function dayLong(ms: number, lang: Lang = 'tr') {
  const p = ist(ms);
  return lang === 'en' ? `${DAYS_L_EN[p.wd]} ${p.d} ${MON_L_EN[p.mo]}` : `${p.d} ${MON_L_TR[p.mo]} ${DAYS_L_TR[p.wd]}`;
}

export const weekdayShort = (ms: number, lang: Lang = 'tr') => (lang === 'en' ? DAYS_EN : DAYS_TR)[ist(ms).wd]!;
export const monShort = (ms: number, lang: Lang = 'tr') => (lang === 'en' ? MON_EN : MON_TR)[ist(ms).mo]!;
export const dateNum = (ms: number) => ist(ms).d;
export const dateNumMon = (ms: number, lang: Lang = 'tr') => `${ist(ms).d} ${monShort(ms, lang)}`;
